import { getApiBaseUrl } from "./env";

export function getApiUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const base = getApiBaseUrl();

  // SSR：Node 环境下必须使用绝对 URL，直连后端
  if (typeof window === "undefined") {
    return `${base}${normalizedPath}`;
  }

  // 浏览器环境统一返回相对路径，交给前端服务器 / 反向代理转发
  // 开发环境：已经通过 Vite proxy 将 /v1.0 指向后端
  // 生产环境：建议由 Nginx 或 Node 服务器将 /v1.0 反向代理到真实后端
  return normalizedPath;
}

/**
 * 创建带查询参数的URL
 * @param baseUrl 基础URL
 * @param params 查询参数对象
 * @returns 带查询参数的完整URL
 */
export function createUrlWithParams(
  baseUrl: string,
  params: Record<string, string | number | boolean | undefined | null>
): string {
  const queryString = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join("&");

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
